import en from "../locales/en.json"
import lv from "../locales/lv.json"
import enAssistantUi from "../locales/en.assistant-ui.json"
import lvAssistantUi from "../locales/lv.assistant-ui.json"
import { initI18n } from "./i18n.lib"

initI18n(
  {
    en: { translation: en, "assistant-ui": enAssistantUi },
    lv: { translation: lv, "assistant-ui": lvAssistantUi }
  },
  ["translation", "assistant-ui"]
)
